import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../../lib/api-client';
import type { AdminUser, CreateAdminInput } from '../../../types/admin';
import { useClaveInmobiliaria } from '../inmobiliaria-activa/inmobiliaria-activa';

/** fix-60 · S-01: administradores de la inmobiliaria activa. */
export function useAdmins() {
  const inmobiliaria = useClaveInmobiliaria();
  return useQuery<AdminUser[]>({
    queryKey: ['admins', inmobiliaria],
    queryFn: () => apiClient.users.admins.list(),
  });
}

function invalidar(queryClient: ReturnType<typeof useQueryClient>): void {
  void queryClient.invalidateQueries({ queryKey: ['admins'] });
}

export function useCreateAdmin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateAdminInput) => apiClient.users.admins.create(data),
    onSuccess: () => invalidar(queryClient),
  });
}

export function useResendAdminInvitation() {
  return useMutation({
    mutationFn: (id: string) => apiClient.users.admins.resendInvitation(id),
  });
}

export function useToggleAdmin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, activo }: { id: string; activo: boolean }) =>
      activo ? apiClient.users.admins.activate(id) : apiClient.users.admins.deactivate(id),
    onSuccess: () => invalidar(queryClient),
  });
}
